import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  fill: "currentColor",
  viewBox: "0 0 128 128"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", { d: "M0 0h61.4L0 60.4zm0 128L128 0H64.6L0 63.7zm128 0L64.6 66.6 3.3 128z" }, null, -1)
  ]));
}
const programmingLanguageKotlin = { render };
export {
  programmingLanguageKotlin as default,
  render
};
//# sourceMappingURL=programming-language-kotlin.svg.js.map
